import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-8 col-12"
}
const _hoisted_2 = { class: "card-body pb-0" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "d-flex align-items-center flex-grow-1" }
const _hoisted_5 = { class: "symbol symbol-45px me-5" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = {
  href: "#",
  class: "text-gray-900 text-hover-primary fs-6 fw-bolder"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-2" }, null, -1)
const _hoisted_9 = { class: "d-flex justify-content-end align-items-center mb-2" }
const _hoisted_10 = { class: "card mb-4" }
const _hoisted_11 = { class: "card-body pb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteModal = _resolveComponent("DeleteModal")!
  const _component_Img = _resolveComponent("Img")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_NoteEditField = _resolveComponent("NoteEditField")!
  const _component_NoteViewField = _resolveComponent("NoteViewField")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_DeleteModal, {
      currentlySelectedEntry: 'note with id ' + _ctx.selectedNoteID,
      onDelete: _ctx.deleteNote
    }, null, 8, ["currentlySelectedEntry", "onDelete"]),
    (_ctx.$can('note_create', 'all'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Img, {
                    src: _ctx.currentUser.photo_url
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.currentUser.name), 1),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentUser.role, (role) => {
                    return (_openBlock(), _createElementBlock("span", {
                      class: "text-gray-400 fw-bold",
                      key: role.id
                    }, _toDisplayString(role.title), 1))
                  }), 128))
                ])
              ])
            ]),
            _withDirectives(_createElementVNode("textarea", {
              class: "w-100 border-0 mt-5 mb-3",
              rows: "2",
              placeholder: "Write a note",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.note) = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.note,
                void 0,
                { trim: true }
              ]
            ]),
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                class: "btn btn-sm btn-light-primary",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveNote && _ctx.saveNote(...args)))
              }, " Add note ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.getData)
      ? (_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: "\n        Currently the user has no notes"
        }))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getData, (note) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "col-12 px-0",
        key: note.id
      }, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.isEdited && _ctx.selectedNoteID == note.id)
              ? (_openBlock(), _createBlock(_component_NoteEditField, {
                  key: 0,
                  comment: _ctx.selectedNoteComment,
                  onDiscard: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isEdited = false)),
                  onSave: _ctx.saveEditedNote
                }, null, 8, ["comment", "onSave"]))
              : (_openBlock(), _createBlock(_component_NoteViewField, {
                  key: 1,
                  note: note,
                  onOpenDeleteModal: _cache[3] || (_cache[3] = 
            noteID => {
              _ctx.selectedNoteID = noteID;
            }
          ),
                  onEdit: _cache[4] || (_cache[4] = 
            noteData => {
              _ctx.selectedNoteComment = noteData.text;
              _ctx.selectedNoteID = noteData.id;
              _ctx.isEdited = true;
            }
          )
                }, null, 8, ["note"]))
          ])
        ])
      ]))
    }), 128))
  ], 64))
}